/*
Looking to add a new experiment?
Read this - https://github.com/wix-private/wix-answers/blob/master/answers-client/core/experiments/README.md
*/
export var featureToggleMap = {
    BobSnippet: {
        petriSpec: 'specs.EnableBobSnippet',
        default: false,
        description: 'Will add a new special Bob snippet in call center insights',
        mergeJira: 'TBD'
    },
    UseWixRecorder: {
        petriSpec: 'specs.UseWixRecorder',
        default: false,
        description: 'Enables user session recording',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12045'
    },
    ArticlesBulkActions: {
        petriSpec: 'specs.ArticlesBulkActions',
        default: false,
        description: 'Will show bulk actions of article list when select articles',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9490'
    },
    WidgetDraggable: {
        petriSpec: 'specs.EnableWidgetDraggable',
        default: false,
        description: 'Enables Widget V3 draggable feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9473'
    },
    WidgetIconMsg: {
        petriSpec: 'specs.EnableWidgetIconMsg',
        default: false,
        description: 'Enables Widget V3 icon msg settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9615'
    },
    WidgetChatbot: {
        petriSpec: 'specs.WidgetChatbot',
        default: false,
        description: 'Enables Chatbot in Widget V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10793'
    },
    SlaPolicies: {
        petriSpec: 'specs.SlaPolicies',
        default: false,
        description: 'Enables SLA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9712'
    },
    CustomFields: {
        petriSpec: 'specs.CustomFields',
        default: false,
        description: 'New Custom Fields Customers / Tickets',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9713'
    },
    ChatDevice: {
        petriSpec: 'specs.ChatDevice',
        default: false,
        description: 'Adds Chat Device to App for AutoAssign feature',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9978'
    },
    GlobalStatus: {
        petriSpec: 'specs.GlobalStatus',
        default: false,
        description: 'New Agent Global Status',
        mergeJira: 'https://jira.wixpress.com/browse/WA-9979'
    },
    ChatAutoAssign: {
        petriSpec: 'specs.ChatAutoAssign',
        default: false,
        description: 'Chat Auto Assign settings page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10093',
    },
    EnableMacros: {
        petriSpec: 'specs.EnableMacros',
        default: false,
        description: 'enables macros on tickets settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10432'
    },
    NewUpgradeFlow: {
        petriSpec: 'specs.NewUpgradeFlow',
        default: false,
        description: 'enables the new upgrade flow and the new package picker for Answers Premium',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10477'
    },
    HelpcenterSettingsV2: {
        petriSpec: 'specs.HelpcenterSettingsV2',
        default: false,
        description: 'enables helpcenter settings V2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10669'
    },
    CallDelay: {
        petriSpec: 'specs.CallDelay',
        default: false,
        description: 'Enables call delay option for agents',
        mergeJira: 'https://jira.wixpress.com/browse/WA-10946'
    },
    CustomFieldsLimit: {
        petriSpec: 'specs.CustomFieldsLimit',
        default: false,
        description: 'Increases custom fields limits',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11019'
    },
    AutoCollapseOnSearch: {
        petriSpec: 'specs.AutoCollapseOnSearch',
        default: false,
        description: 'Article viewer collapsible auto collapse on cmd+f',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11103'
    },
    ChatArticleSuggestions: {
        petriSpec: 'specs.ChatArticleSuggestions',
        default: false,
        description: 'enables article suggestions in chat reply',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11256',
    },
    FinnishSupportedLang: {
        petriSpec: 'specs.FinnishSupportedLang',
        default: false,
        description: 'Shows Finnish as support lang',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11255'
    },
    CompactCallDevice: {
        petriSpec: 'specs.CompactCallDevice',
        default: false,
        description: 'Call Device redesign',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11304'
    },
    HotkeysPort: {
        petriSpec: 'specs.HotkeysPort',
        default: false,
        description: 'Enables actions triggered by hotkeys port',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11461'
    },
    ChatHotkeys: {
        petriSpec: 'specs.ChatHotkeys',
        default: false,
        description: 'Enables hotkeys for Chat Jira: WA-11436',
        mergeJira: 'TBD'
    },
    ChatReplyAndGo: {
        petriSpec: 'specs.ChatReplyAndGo',
        default: false,
        description: 'Agent reply and go to next chat',
        mergeJira: 'https://jira.wixpress.com/browse/WA-11443'
    },
    WhatsappAttachments: {
        petriSpec: 'specs.WhatsappAttachments',
        default: false,
        description: 'Enables Whatsapp attachments from the App to Whatsapp',
        mergeJira: 'TBD - internal'
    },
    LowCreditBlock: {
        petriSpec: 'specs.LowCreditBlock',
        default: false,
        description: 'Blocks reply area when the account is low on credits.',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12460'
    },
    RemoveCreditBlock: {
        petriSpec: 'specs.RemoveCreditBlock',
        default: false,
        description: 'Removes Ticket Page block when credits are insufficient.',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12357'
    },
    UploadZipFiles: {
        petriSpec: 'specs.UploadZipFiles',
        default: false,
        description: 'Enables uploading zip files (made for MH)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12135'
    },
    DashboardOutboundCallsAndTotalTime: {
        petriSpec: 'specs.DashboardOutboundCallsAndTotalTime',
        default: false,
        description: 'Patch for outbound sales MH account (and others) to include outbound calls to dashboard without adding filters to the UI. This also adds a "total call time" in the agents table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12295'
    },
    TicketsListNewPresenceComponent: {
        petriSpec: 'specs.TicketsListNewPresenceComponent',
        default: false,
        description: 'Enables new ticket list presence design',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12391',
    },
    SlaSettingsV2: {
        petriSpec: 'specs.SlaSettingsV2',
        default: false,
        description: 'Enables SLA settings v2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12461'
    },
    EditCategoryIconSrc: {
        petriSpec: 'specs.EditCategoryIconSrc',
        default: false,
        description: 'Allows editing of category icon by source only, while keeping the icon key. Needed for new HC',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12515'
    },
    AnswersEnableChatWebhooksDigibankPOC: {
        petriSpec: 'specs.AnswersEnableChatWebhooksDigibankPOC',
        default: false,
        description: 'Enables chat webhooks for digibank POC - client and server',
        mergeJira: 'https://jira.wixpress.com/browse/WONT-BE-MERGED'
    },
    ControlRoom: {
        petriSpec: 'specs.ControlRoom',
        default: false,
        description: 'Control room page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12754'
    },
    ExtendFacebookReplyPeriod: {
        petriSpec: 'specs.ExtendFacebookReplyPeriod',
        default: false,
        description: 'Extends Facebook\'s 7 days to reply period to 21 days',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12760'
    },
    OneInbox: {
        petriSpec: 'specs.OneInbox',
        default: false,
        description: 'One Inbox page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-12763'
    },
    CompanyFieldsM5: {
        petriSpec: 'specs.CompanyFieldsM5',
        default: false,
        description: 'Enables company fields and new ticket/customer fields in ticket page side bar',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13081',
    },
    AdvancedReportsWasabi: {
        petriSpec: 'specs.AdvancedReportsWasabi',
        default: false,
        description: 'wasabi insights reports',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13148'
    },
    CallTypeIndicator: {
        petriSpec: 'specs.CallTypeIndicator',
        default: false,
        description: 'add a call type column to call center',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13463'
    },
    WorkflowsBetaScenarios: {
        petriSpec: 'specs.WorkflowsBetaScenarios',
        default: false,
        description: 'Opening this experiment enables spotter scenarios that are still in dev',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14377'
    },
    AutoRouting: {
        petriSpec: 'specs.AutoRouting',
        default: false,
        description: 'helpdesk auto routing',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13513'
    },
    FasterPollingTicketList: {
        petriSpec: 'specs.FasterPollingTicketList',
        default: false,
        description: 'for qa, faster ticket list polling',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13598'
    },
    BreachRules: {
        petriSpec: 'specs.BreachRules',
        default: false,
        description: 'Step 3 on SLA Settings V2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13703'
    },
    NewAgentStatus: {
        petriSpec: 'specs.NewAgentStatus',
        default: false,
        description: 'Global Agent status V3',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13767'
    },
    AutoRoutingDevice: {
        petriSpec: 'specs.AutoRoutingDevice',
        default: false,
        description: 'New push notifications device',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13911'
    },
    HotJarForNewAccounts: {
        petriSpec: 'specs.HotJarForNewAccounts',
        default: true,
        description: 'Hot Jar for new accounts',
        mergeJira: 'https://jira.wixpress.com/browse/WA-13905'
    },
    CCAccountManager: {
        petriSpec: 'specs.CcAccountManager',
        default: false,
        description: 'Dynamically cc the associated account manager',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14114'
    },
    OutboundChat: {
        petriSpec: 'specs.OutboundChat',
        default: false,
        description: 'Enables the option to open an outbound chat',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14070'
    },
    NewTicketModal: {
        petriSpec: 'specs.NewTicketModal',
        default: false,
        description: 'renders the new refactored ticket modal',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14131'
    },
    Partners: {
        petriSpec: 'specs.EnablePartners',
        default: false,
        description: 'enables partner users in app',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14133'
    },
    ForceHotjarTracking: {
        petriSpec: 'specs.ForceHotjarTracking',
        default: false,
        description: 'forces hotjar tracking',
        mergeJira: 'should never be merged'
    },
    JiraIntegrationV2: {
        petriSpec: 'specs.JiraIntegrationV2',
        default: false,
        description: 'enables new features for Jira Integration',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14172'
    },
    NewBusyStatus: {
        petriSpec: 'specs.NewBusyStatus',
        default: false,
        description: 'move custom statuses to account settinga',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14208'
    },
    ReplyBoxShowAllEmojis: {
        petriSpec: 'specs.ReplyBoxShowAllEmojis',
        default: false,
        description: 'does not limit emojis shown in reply box (WA-13278)',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14176'
    },
    RuleEngineCompanyFields: {
        petriSpec: 'specs.RuleEngineCompanyFields',
        default: false,
        description: 'Shows company fields in Rule Engine',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14252'
    },
    CustomCompanyFieldsFilters: {
        petriSpec: 'specs.CustomCompanyFieldsFilters',
        default: false,
        description: 'Enables custom company fields in One Inbox Views',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14413'
    },
    CompanyTimeZone: {
        petriSpec: 'specs.CompanyTimeZone',
        default: false,
        description: 'https://jira.wixpress.com/browse/WA-14342'
    },
    CompanyCustomFieldsMacros: {
        petriSpec: 'specs.CompanyCustomFieldsMacros',
        default: false,
        description: 'https://jira.wixpress.com/browse/WA-14625'
    },
    JiraIntegrationSettingsV2: {
        petriSpec: 'specs.JiraIntegrationSettingsV2',
        default: false,
        description: 'https://jira.wixpress.com/browse/WA-14411'
    },
    AnswersDuplexerReviveMechanism: {
        petriSpec: 'specs.AnswersDuplexerReviveMechanism',
        default: false,
        description: 'answers revive mechanism to duplexer idle network error',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14508'
    },
    TwilioClientMinorVersion13: {
        petriSpec: 'specs.TwilioClientMinorVersion13',
        default: false,
        description: 'experimental'
    },
    SmsTicket: {
        petriSpec: 'specs.SmsTicket',
        default: false,
        description: 'New channel for sms',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14545'
    },
    ShowCompanyTicketsInRecentTickets: {
        petriSpec: 'specs.ShowCompanyTicketsInRecentTickets',
        default: false,
        description: 'https://jira.wixpress.com/browse/WA-14716',
        mergeJira: 'Temp for SiSense, will not be merged before proper UX'
    },
    NewSmsTicketModal: {
        petriSpec: 'specs.NewSmsTicketModal',
        default: false,
        description: 'Modal for new sms ticket',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14722'
    },
    NewLinesSettingsTable: {
        petriSpec: 'specs.NewLinesSettingsTable',
        default: false,
        description: 'New line settings table',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14635'
    },
    HelpcenterV2P2: {
        petriSpec: 'specs.HelpcenterV2P2',
        default: false,
        description: 'Enables P2 features in HelpcenterV2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14667'
    },
    SpotterP2: {
        petriSpec: 'specs.SpotterP2',
        default: false,
        description: 'Enables P2 features in spotter',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14707'
    },
    AgentLocaleInterfacePicker: {
        petriSpec: 'specs.AgentLocaleInterfacePicker',
        default: false,
        description: 'Enables agent locale interface picker from user editor',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14721'
    },
    HC2DetailedList: {
        petriSpec: 'specs.HC2DetailedList',
        default: false,
        description: 'Enables Detailed List layout for categories section in HCv2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14731'
    },
    PasteHTMLContentToTextEditor: {
        petriSpec: 'specs.PasteHTMLContentToTextEditor',
        default: false,
        description: 'Better handling of pasted HTML in Text Editor',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14730'
    },
    TimelinePreview: {
        petriSpec: 'specs.TimelinePreview',
        default: false,
        description: 'Timeline popover preview',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14747'
    },
    HC2SectionsCodeOverrides: {
        petriSpec: 'specs.HC2SectionsCodeOverrides',
        default: false,
        description: 'Enables code overrides for all sections in HCv2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14769'
    },
    APIReactQuery: {
        petriSpec: 'specs.AnswersAPIReactQuery',
        default: false,
        description: 'Wraps the API layer with React Query',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14859'
    },
    OneInboxCache: {
        petriSpec: 'specs.AnswersOneInboxCache',
        default: false,
        description: 'Enables the cache layer for OneInbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15339'
    },
    TicketPriorityBusinessHours: {
        petriSpec: 'specs.TicketPriorityBusinessHours',
        default: false,
        description: 'enables the option to add business hours to ticket priorities in sla v2 modal',
        mergeJira: 'https://jira.wixpress.com/browse/WA-14835'
    },
    HC2CustomSection: {
        petriSpec: 'specs.HC2CustomSection',
        default: false,
        description: "adds ability to add a custom section to tenant's helpcenter v2",
        mergeJira: 'https://jira.wixpress.com/browse/WA-15043'
    },
    HC2ArticleInfo: {
        petriSpec: 'specs.HC2ArticleInfo',
        default: false,
        description: 'Enables settings for article info in article pages in HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15054'
    },
    ChatbotBuilderPOC: {
        petriSpec: 'specs.ChatbotBuilderPOC',
        default: false,
        description: 'POC of chatbot builder',
        mergeJira: 'Wont merge'
    },
    WasabiMocks: {
        petriSpec: 'specs.WasabiMocks',
        default: false,
        description: 'wasabi mock reports for marketing use',
        mergeJira: 'wont merge'
    },
    WorkflowsBetaConditions: {
        petriSpec: 'specs.WorkflowsBetaConditions',
        default: false,
        description: 'Hides spotter conditions that did not go through QA',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15171'
    },
    BatchBiEvents: {
        petriSpec: 'specs.BatchBiEvents',
        default: false,
        description: 'send bi events in batches',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15210'
    },
    NewAgentModal: {
        petriSpec: 'specs.NewAgentModal',
        default: false,
        description: 'new agent modal with control room/auto routing/ global status additions',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15223'
    },
    HC2SeparateCustomCode: {
        petriSpec: 'specs.HC2SeparateCustomCode',
        default: false,
        description: 'Enables new api for getting and updating separate custom js and css code for HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15355'
    },
    LogDuplexerMessages: {
        petriSpec: 'specs.LogDuplexerMessages',
        default: false,
        description: 'logs all duplexer messages for debug purposes',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15401'
    },
    HC2CategoryImageScale: {
        petriSpec: 'specs.HC2CategoryImageScale',
        default: false,
        description: 'Enables support for scale category image in HC2 settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15444'
    },
    OBAsDefaultPageForTrialUsers: {
        petriSpec: 'specs.OBAsDefaultPageForTrialUsers',
        default: false,
        description: 'set OB page as default landing page for trial users',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15433'
    },
    CallcenterLogs: {
        petriSpec: 'specs.CallcenterLogs',
        default: false,
        description: 'enables debug logs for callcenter',
        mergeJira: 'TBD'
    },
    CallCenterRemoveDelays: {
        petriSpec: 'specs.CallCenterRemoveDelays',
        default: false,
        description: 'removes delays for stop polling in callcenter',
        mergeJira: 'TBD'
    },
    HCNextPrevArticle: {
        petriSpec: 'specs.HCNextPrevArticle',
        default: false,
        description: 'enables settings for next prev buttons',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15470'
    },
    NewRecentTickets: {
        petriSpec: 'specs.NewRecentTickets',
        default: false,
        description: 'New Recent Tickets UX version',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15550'
    },
    KnowledgeBaseComments: {
        petriSpec: 'specs.KnowledgeBaseComments',
        default: false,
        description: 'Comments in Answers KB',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15396'
    },
    HC2HeroSideBySide: {
        petriSpec: 'specs.HC2HeroSideBySide',
        default: false,
        description: 'enables side-by-side layout in top-section HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15611'
    },
    DisableMobileLock: {
        petriSpec: 'specs.DisableMobileLock',
        default: false,
        description: 'disables mobile lock',
        mergeJira: 'TBD'
    },
    NewTenantsOneInbox: {
        petriSpec: 'specs.NewTenantsOneInbox',
        default: false,
        description: 'opens one inbox to new tenants from specific date',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15545'
    },
    DynamicSupportedFileTypes: {
        petriSpec: 'specs.DynamicSupportedFileTypes',
        default: false,
        description: 'Adds support for server defined list of supported file types for uploads in answers app',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15623'
    },
    HC2CategoriesColumns: {
        petriSpec: 'specs.HC2CategoriesColumns',
        default: false,
        description: 'Adds support for items per row settings in categories pages HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15659'
    },
    ImageComponentWidth: {
        petriSpec: 'specs.ImageComponentWidth',
        default: false,
        description: 'Enables 100% max width for image in image-component',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15709'
    },
    OneInboxChatStats: {
        petriSpec: 'specs.OneInboxChatStats',
        default: false,
        description: 'Enables Chat Stats in OI, requested by WIX',
        mergeJira: 'TBD'
    },
    ShowOneInboxVideo: {
        petriSpec: 'specs.ShowOneInboxVideo',
        default: false,
        description: 'Shows one inbox video on first time usage',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15725'
    },
    HC2AllLevelsDetailedList: {
        petriSpec: 'specs.HC2AllLevelsDetailedList',
        default: false,
        description: 'Enables all levels detailed list layout for categories in HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15780'
    },
    OneInboxAlpha: {
        petriSpec: 'specs.OneInboxAlpha',
        default: false,
        description: 'One Inbox development FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15783'
    },
    MultiBrand: {
        petriSpec: 'specs.MultiBrand',
        default: false,
        description: 'MultiBrand FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15799'
    },
    HCSidebarNavigation: {
        petriSpec: 'specs.SidebarNavigation',
        default: false,
        description: 'HC Sidebar Navigation',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15577'
    },
    SlaInsightsV2: {
        petriSpec: 'specs.SlaInsightsV2',
        default: false,
        description: 'enables the sla insights v2 inside new ticket insights',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15860'
    },
    FreeTrialHelpWidget: {
        petriSpec: 'specs.FreeTrialHelpWidget',
        default: false,
        description: 'Free Trial Help Widget',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15770'
    },
    SpotterDynamicAction: {
        petriSpec: 'specs.SpotterDynamicAction',
        default: false,
        description: 'Spotter dynamic actions FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15853'
    },
    LibbyUseDomPurifySanitizer: {
        petriSpec: 'specs.LibbyUseDomPurify',
        default: false,
        description: 'ditto',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15900'
    },
    OneInboxChatSoundNotification: {
        petriSpec: 'specs.OneInboxChatSoundNotification',
        default: false,
        description: 'Play sound notification when there is a new chat in One Inbox',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15985'
    },
    QueuePriority: {
        petriSpec: 'specs.QueuePriority',
        default: false,
        description: 'queue priority FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15929'
    },
    CustomerPortalSettings: {
        petriSpec: 'specs.CustomerPortalSettings',
        default: false,
        description: 'Customer portal settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15991'
    },
    AutoRoutingBrowserNotifications: {
        petriSpec: 'specs.AutoRoutingBrowserNotifications',
        default: false,
        description: 'enables auto routing browser notifications',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15995'
    },
    OneInboxChatStatusFilter: {
        petriSpec: 'specs.OneInboxChatStatusFilter',
        default: false,
        description: 'add filter by chat status to OI',
        mergeJira: 'https://jira.wixpress.com/browse/WA-15979'
    },
    HC2NewCustomFontSettings: {
        petriSpec: 'specs.HC2NewCustomFontSettings',
        default: false,
        description: 'enables new external custom font settings in HC2',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16117'
    },
    RemoveRedundantFlowsCC: {
        petriSpec: 'specs.RemoveRedundantFlowsCC',
        default: false,
        description: 'Removes redundant flows in Call center, this FT will help on removing this flows',
        mergeJira: 'TBD'
    },
    FacebookIndicationOnTicketPage: {
        petriSpec: 'specs.FacebookIndicationOnTicketPage',
        default: false,
        description: 'Add Facebook indication on ticket page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16125'
    },
    TimelineRealTime: {
        petriSpec: 'specs.TimelineRealTime',
        default: false,
        description: 'real time in ticket timeline',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16137'
    },
    EmailOpenIndication: {
        petriSpec: 'specs.EmailOpenIndication',
        default: false,
        description: 'adds sent and read indication for agent replies',
        mergeJira: 'TBD'
    },
    ExpiredSessionAlert: {
        petriSpec: 'specs.ExpiredSessionAlert',
        default: false,
        description: 'shows ExpiredSessionAlert for status 401 on APIs',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16173'
    },
    PositionInLine: {
        petriSpec: 'specs.PositionInLine',
        default: false,
        description: 'shows position in line in chat widget + chat settings page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16149'
    },
    NewFacebookFilters: {
        petriSpec: 'specs.NewFacebookFilters',
        default: false,
        description: 'filter by facebook source and page',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16187'
    },
    MacrosAssigneActiveUser: {
        petriSpec: 'specs.MacrosAssigneActiveUser',
        default: false,
        description: 'Active User Option in Macros Assigne Select',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16175'
    },
    WidgetWrapUrls: {
        petriSpec: 'specs.WidgetWrapUrls',
        default: false,
        description: 'Wrap Urls in a elements before submitting',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16300'
    },
    Schedules: {
        petriSpec: 'specs.Schedules',
        default: false,
        description: 'enables new schedules page and app menu item',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16186'
    },
    FacebookRepliesTextFormatting: {
        petriSpec: 'specs.FacebookRepliesTextFormatting',
        default: false,
        description: 'format Facebook replies',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16289'
    },
    SpotterPopoverSelector: {
        petriSpec: 'specs.SpotterPopoverSelector',
        default: false,
        description: 'Spotter popover selector FT',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16292'
    },
    DisableChatInputOutsideBusinsessHours: {
        petriSpec: 'specs.DisableChatInputOutsideBusinsessHours',
        default: false,
        description: 'disables chat input outside chat business hours',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16293'
    },
    ReopenChatSettings: {
        petriSpec: 'specs.ReopenChatSettings',
        default: false,
        description: 'allows reopen chat from chat settings',
        mergeJira: 'https://jira.wixpress.com/browse/WA-16348'
    },
};
//# sourceMappingURL=features.js.map